import { render, staticRenderFns } from "./JobTemplateInfoCard.vue?vue&type=template&id=48553cc2&"
import script from "./JobTemplateInfoCard.vue?vue&type=script&lang=js&"
export * from "./JobTemplateInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports